import React from "react"
import { Link } from "react-router-dom"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import { adminName, adminRole, adminEmail, adminStatus, adminCreatedAt, canManageAdmins } from "./adminDisplay"
import "../../../assets/scss/custom/components/_directoryActions.scss"

export default ({ listSearch, userDetails = {}, onDelete }) => {
  const path = (row, edit = false) => ({ pathname: "/accounts/admins/" + row.id + (edit ? "/edit" : ""), state: { adminListSearch: listSearch } })
  return [
    { dataField: "name", text: "Administrator", formatter: (_, row) => <div className="admin-cell">
      <Link className="club-list-name" to={path(row)}>{adminName(row)}</Link>
      <small className="text-muted">#{row.userId ?? "—"} · {adminRole(row.role)}</small>
      {row.id === userDetails.id && <span className="badge badge-soft-info">You</span>}
    </div> },
    { dataField: "email", text: "Email", formatter: (_, row) => adminEmail(row) },
    { dataField: "status", text: "Status", formatter: adminStatus },
    { dataField: "createdAt", text: "Account created", formatter: value => adminCreatedAt(value) },
    { dataField: "actions", text: "Actions", formatter: (_, row) => <div className="directory-row-actions admin-actions">
      <Link to={path(row)} className="btn btn-outline-primary btn-sm directory-action-button" aria-label={"Open admin: " + adminName(row)}>Open</Link>
      {canManageAdmins(userDetails) && row.status !== "deleted" && <UncontrolledDropdown>
        <DropdownToggle tag="button" type="button" className="btn btn-light btn-sm directory-action-button" aria-label={"Actions for " + adminName(row)}>
          <i className="bx bx-dots-horizontal-rounded" aria-hidden="true" />
        </DropdownToggle>
        <DropdownMenu right><DropdownItem tag={Link} to={path(row, true)}>Edit admin</DropdownItem>
          {row.id !== userDetails.id && onDelete && <DropdownItem onClick={() => onDelete(row)}>Delete admin</DropdownItem>}
        </DropdownMenu>
      </UncontrolledDropdown>}
    </div> },
  ]
}
